import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LotesRepasseModule } from './pages/lotes-repasse/lotes-repasse.module';
import { LotesFaturamentoModule } from './pages/lotes-faturamento/lotes-faturamento.module';
import { AprovacaoModule } from './pages/aprovacao/aprovacao.module';
import { ComissaoFaturamentoModule } from './pages/comissao-faturamento/comissao-faturamento.module';
import { ContratosModule } from './pages/contratos/contratos.module';
import { EsteiraApuracaoModule } from './pages/esteira-apuracao/esteira-apuracao.module';
import { ConfiguracoesModule } from './pages/configuracoes/configuracoes.module';
import { AuthComponent } from './core/components/auth/auth.component';
import { SairModule } from './pages/sair/sair.module';
import { ConfiguracaoNfModule } from './pages/configuracao-nf/configuracao-nf.module';
import { CodigosServicoModule } from './pages/codigos-servico/codigos-servico.module';

const routes: Routes = [
  {
    path: 'esteira-apuracao',
    loadChildren: () => EsteiraApuracaoModule
  },
  {
    path: 'faturamento-contratos',
    // loadChildren: () => RepasseComissaoModule
    loadChildren: () => LotesFaturamentoModule
  },
  {
    path: 'repasse-comissao',
    loadChildren: () => LotesRepasseModule
  },
  {
    path: 'comissao-faturamento',
    loadChildren: () => ComissaoFaturamentoModule
  },
  {
    path: 'contratos',
    loadChildren: () => ContratosModule
  },
  {
    path: 'aprovacao',
    loadChildren: () => AprovacaoModule
  },
  {
    path: 'autenticacao',
    component: AuthComponent
  },
  {
    path: 'configuracoes',
    loadChildren: () => ConfiguracoesModule
  },
  {
    path: 'sair',
    loadChildren: () => SairModule
  },
  {
    path: 'configuracao-nf',
    loadChildren: () => ConfiguracaoNfModule
  },
  {
    path: 'codigos-servico',
    loadChildren: () => CodigosServicoModule
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'esteira-apuracao'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
